import { useUserProfile } from "@shared/hooks/useUserProfile";
import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import theme from "@shared/utils/themeColors";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { MembersSidebar } from "../components/MembersSidebar";
import ProfileCard from "../components/ProfileCard";

const Connections: React.FC = () => {
  const { userId: userIdFromUrl } = useParams<{ userId?: string }>();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState<string | undefined>(userIdFromUrl);

  const { profile: selectedProfile, refetch } = useUserProfile(selectedUserId, {
    include: ["tests"],
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  return (
    <AuthenticatedLayout>
      <div className="relative flex">
        {/* Members sidebar */}
        <MembersSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onSelectUser={setSelectedUserId}
          selectedUserId={selectedUserId}
        />

        {/* Profile content */}
        {selectedProfile ? (
          <ProfileCard
            profile={selectedProfile}
            onRefresh={refetch}
            setProfileSidebarOpen={setSidebarOpen}
            profileSidebarOpen={sidebarOpen}
          />
        ) : (
          <div className="p-4">
            <p className={theme.text.muted}>
              Select a connection to view their profile
            </p>
          </div>
        )}
      </div>
    </AuthenticatedLayout>
  );
};

export default Connections;
